import React from "react";
import { Input } from "reactstrap";

interface Props {
  contractData: any;
  handleCheckboxChange: (data: string) => void;
  onInputChange: (newValue: string) => void;
  isEditDisabled?: boolean;
}

const ActionCard = ({ contractData, handleCheckboxChange, isEditDisabled,onInputChange }: Props) => {
  return (
    <div className="col-lg-4 col-md-4">
      <div className="action-card-container">
        <div className="action-card-checkbox-container">
          <input
            type="checkbox"
            className="action-card-checkbox"
            value={contractData?.isNegotiationActionUsed}
            disabled={isEditDisabled}
            checked={contractData?.isNegotiationActionUsed}
            onChange={() => handleCheckboxChange(contractData?.id)}
          />
        </div>
        <div className="action-card-title">
          {contractData?.negotiationActionTitle}
        </div>
        <div className="action-card-description">
          {contractData?.negotiationActionDescription}
        </div>
        <div className="action-card-implementation-plan-container">
          <div className="action-card-implementation-plan-header">
            My Implementation Plan:
          </div>
          <div >
            <Input
              type="textarea"
              rows={5}
              placeholder="..."
              value= {contractData.implementationApproach || ""}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                const trimmed = e.target.value.slice(0, 1000);
                onInputChange(trimmed);
              }}
              style={{ fontSize: "14px", marginTop: "5px" }}
            />
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ActionCard);
